import script from "./productBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./productBasic.vue?vue&type=script&lang=ts&setup=true"

import "./productBasic.vue?vue&type=style&index=0&id=22171d2f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22171d2f"]])

export default __exports__